import LocationOnIcon from "@material-ui/icons/LocationOn";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import BusinessIcon from "@material-ui/icons/Business";
import { Grid, TextField } from "@material-ui/core";
import { useContext, useEffect } from "react";

import "./accessDetails.css";
import { ThemeContext } from "../../../../../../../../../contexts";

const AccessDeatils = (): JSX.Element => {
	const { theme } = useContext(ThemeContext);

	return (
		<div className="clinic-card-access-details">
			<div className="theme-plan-header">Access Details</div>
			<div className="theme-plan-sub-header" style={{ borderLeftColor: theme.primary_color }}>
				Access To Entira Clinic Located in Lufkin, Texas
			</div>
			<div className="theme-plan-inner-section-margin" />

			<Grid container spacing={1}>
				<Grid item xs={12} sm={12} md={4} lg={4} xl={4} className="align-center">
					<LocationOnIcon className="access-icon" style={{ color: theme.primary_color }} />
					<div className="access-header">Location</div>
					<div className="access-content">
						1807 W. Frank, Suite 100. Lufkin, TX 75904<br></br>
						936-634-1400 <br></br>(Click on Address for Directions)
					</div>
				</Grid>
				<Grid item xs={12} sm={12} md={4} lg={4} xl={4} className="align-center">
					<AccessTimeIcon className="access-icon" style={{ color: theme.primary_color }} />
					<div className="access-header">Hours of Operation</div>
					<div className="access-content">
						8.00 AM - 5:00 PM Monday thru Friday<br></br>
						Noon - 1.00 PM Closed
					</div>
				</Grid>
				<Grid item xs={12} sm={12} md={4} lg={4} xl={4} className="align-center">
					<BusinessIcon className="access-icon" style={{ color: theme.primary_color }} />
					<div className="access-header">Headquarters</div>
					<div className="access-content">
						Entira Medical Clinics<br></br> 14800 Quorum Drive, Suite 510<br></br> Dalas, TX 75254<br></br>
						<br></br>
						1-800-741-0135<br></br> Email: info@entiraclinic.com<br></br> Website www entiraclinic com
					</div>
				</Grid>
			</Grid>
		</div>
	);
};

export default AccessDeatils;
